import React from "react";

const MSG = "Reviewers are not allowed to perform this action";

// Wraps a mutating control. When `active` (the current user is a reviewer),
// the child is rendered non-interactive (dimmed + pointer-events-none) and a
// tooltip appears on hover. When inactive it returns the child untouched, so
// non-reviewers see no change at all.
//
// Props:
//  - active: boolean — gate on/off
//  - block:  boolean — use for full-width rows (e.g. dropdown menu items)
//  - place:  "top" | "bottom" | "left" — tooltip placement (avoid clipping)
//  - msg:    string  — tooltip text (defaults to the reviewer-specific message)
export default function ReviewerActionGate({
  active,
  children,
  block = false,
  place = "top",
  msg = MSG,
}) {
  if (!active) return children;

  const pos =
    place === "left"
      ? "right-full top-1/2 -translate-y-1/2 mr-2"
      : place === "bottom"
      ? "top-full left-1/2 -translate-x-1/2 mt-2"
      : "bottom-full left-1/2 -translate-x-1/2 mb-2";

  return (
    <span
      className={`relative ${block ? "flex w-full" : "inline-flex"} group/rev`}
    >
      <span className={`${block ? "w-full" : ""} pointer-events-none opacity-50`}>
        {children}
      </span>
      <span
        className={`pointer-events-none absolute ${pos} z-[10000] hidden group-hover/rev:block w-max max-w-[220px] whitespace-normal rounded-md bg-[#4A4A4A] px-3 py-2 text-[12px] font-normal leading-snug text-white shadow-lg`}
      >
        {msg}
      </span>
    </span>
  );
}
